module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@3x-d5668e72dab976631a40392bd093b566.png";